import { useTranslation } from 'react-i18next';

import { PageContainer } from '../../../../components/molecules/page-container';
import { PageHeader } from '../../../../components/molecules/page-header';
import { CreateVisit as CreateVisitComponent } from '../organisms/create-visit/create-visit';

import { withPermissions } from '@/permissions/can';

const CreateVisit = () => {
  const { t } = useTranslation(['createVisit']);

  return (
    <PageContainer helmetPageTitle={t('createVisit:tab')} fillAvailableHeight>
      <PageHeader title={t('createVisit:title')} />
      <CreateVisitComponent />
    </PageContainer>
  );
};

export default withPermissions(
  permissions => permissions.cannot('create', 'Visitors'),
  CreateVisit,
);
